/**
 * @file About.js
 * @author Stanley Chen
 * @description About component that displays information about Kiku Japanese Steakhouse
 * with an animated text section and image
 */

import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { Link } from 'react-router-dom'; 
import './About.css';

const About = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.3 });
  
  return (
    <section className="about-section" id="about" ref={ref}>
      <div className="about-container">
        <div className="about-content">
          <motion.div 
            className="about-text"
            initial={{ opacity: 0, x: -100 }}
            animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: -100 }}
            transition={{ duration: 0.8 }}
          >
            <h2>ABOUT US</h2>
            <p>
            Love Japanese food? If you haven’t tried hibachi yet, you’re missing out! At Kiku Japanese Steakhouse & Sushi in Middletown, DE, our skilled chefs cook your meal right in front of you—turning dinner into a show. Enjoy fresh sushi, sizzling teppanyaki, and a fun, unforgettable dining experience. We look forward to sharing this cuisine with you!
            </p>
            <Link to="/menu" state={{ activeCategory: 'hibachi' }}>
              <motion.button 
                className="primary-btn"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                VIEW MENU
              </motion.button>
            </Link>
          </motion.div>
          
          <div className="about-image-wrapper">
            <div className="about-border"></div>
            <motion.div 
              className="about-image"
              initial={{ opacity: 0, x: 100 }}
              animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: 100 }}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              <img src="/images/about.jpg" alt="" />
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;